import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ApiService from "../services/ApiService";
import "./CarTypeSelection.css";

const CarTypeSelection = () => {
  const [carTypes, setCarTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedCarType, setSelectedCarType] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetchCarTypes();
  }, []);

  const fetchCarTypes = async () => {
    try {
      setLoading(true);
      const response = await ApiService.getAllCarTypes();
      setCarTypes(response.data || []);
    } catch (error) {
      console.error("Error fetching car types:", error);
      setError("Failed to load car types. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCarTypeSelect = (carType) => {
    setSelectedCarType(carType);
  };
  const handleContinue = () => {
    if (selectedCarType) {
      // Navigate to pricing plan selection with the selected car type
      navigate("/purchase-plan", {
        state: {
          selectedCarType,
          fromPurchaseFlow: true,
        },
      });
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="car-type-selection-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading car types...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="car-type-selection-container">
        <div className="error-message">
          <h3>Error</h3>
          <p>{error}</p>
          <button onClick={fetchCarTypes} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="car-type-selection-container">
      <div className="car-type-selection-header">
        <button onClick={handleGoBack} className="back-button">
          ← Back
        </button>
        <h2>Select Your Car Type</h2>
        <p>Choose your vehicle type to see available pricing plans</p>
      </div>

      <div className="car-types-grid">
        {carTypes.map((carType) => (
          <div
            key={carType.id}
            className={`car-type-card ${
              selectedCarType?.id === carType.id ? "selected" : ""
            }`}
            onClick={() => handleCarTypeSelect(carType)}
          >
            <div className="car-type-icon">🚗</div>
            <h3>{carType.name}</h3>
            <div className="car-type-description">
              Perfect for {carType.name.toLowerCase()} vehicles
            </div>
          </div>
        ))}
      </div>

      {carTypes.length === 0 && (
        <div className="no-car-types">
          <p>No car types available at the moment.</p>
          <p>Please contact support for assistance.</p>
        </div>
      )}

      {selectedCarType && (
        <div className="selection-summary">
          <div className="selected-car-type">
            <h4>Selected: {selectedCarType.name}</h4>
            <p>You can now view pricing plans for this vehicle type</p>
          </div>

          <div className="action-buttons">
            <button onClick={handleContinue} className="continue-button">
              Continue to Pricing Plans →
            </button>
          </div>
        </div>
      )}

      {!selectedCarType && carTypes.length > 0 && (
        <div className="selection-prompt">
          <p>Please select your car type to continue</p>
        </div>
      )}
    </div>
  );
};

export default CarTypeSelection;
